// extracted by mini-css-extract-plugin
module.exports = {"posts":"blog-module--posts--33ja6"};